module.exports = __webpack_public_path__ + "static/media/asterisk.be737800.svg";